"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoCall/segments/AudioSetupGroup.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }// Audio setup section, used to tweak user's audio settings.
var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);




var _videoCall = require('web/selectors/videoCall');
var _hooks = require('web/services/hooks');

var _Audio = require('web/components/VideoCall/Setup/SetupGroups/Audio'); var _Audio2 = _interopRequireDefault(_Audio);
var _useSetupStream = require('./useSetupStream');





// Was a class inside connect(): memo keeps connect's props bail-out.
const AudioSetupGroupContainer = ({ onUserProblemPublish }) => {
  const audioInDevices = _hooks.useAppSelector.call(void 0, _videoCall.selectAudioInDevices)
  const areMicIssuesPresent = _hooks.useAppSelector.call(void 0, _videoCall.selectAreMicIssuesPresent)
  const currentMicDeviceId = _hooks.useAppSelector.call(void 0, _videoCall.selectCurrentMicDeviceId)

  const stream = _useSetupStream.useSetupStream.call(void 0, 'mic', currentMicDeviceId, onUserProblemPublish)

  return (
    _react2.default.createElement(_Audio2.default, {
      audioStream: stream,
      audioInDevices: audioInDevices,
      currentMicDeviceId: currentMicDeviceId,
      areMicIssuesPresent: areMicIssuesPresent,
      setCurrentMicDeviceId: _actions2.default.setCurrentMicDeviceId, __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}
    )
  )
}

exports. default = _react.memo.call(void 0, AudioSetupGroupContainer)
